import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AngularFireDatabase} from "angularfire2/database";
import {AngularFireAuth} from "angularfire2/auth";

@Component({
  selector: 'app-basic-info',
  templateUrl: './basic-info.component.html',
  styleUrls: ['./basic-info.component.css']
})
export class BasicInfoComponent implements OnInit, OnDestroy {
  volunteerForm: FormGroup;
  submitSuccess: boolean;
  branches: string[] = ['Mechanical Engineering',
    'Computer Science Engineering',
    'Information Technology',
    'Electronics Instrumentation Engineering',
    'Electronics Communication Engineering',
    'Electrical and Electronics Engineering',
    'Civil Engineering',
    'Chemical Engineering',
    'Environmental Engineering',
    'Bio-Technology',
    'Automobile Engineering'
  ];
  // emails = [{email: 'email1'}, {email: 'email2'}, {email: 'email3'}, {email: 'email4'}];
  roles = [{role: 'Web Development and Design'},
    {role: 'Social Media'},
    {role: 'Marketing and advertisements'},
    {role: 'Media and Public Relations'},
    {role: 'Content_Editor'
    }];
  volunteer: any;
  constructor(private fb: FormBuilder, public af: AngularFireDatabase, public afAuth: AngularFireAuth) {

    this.volunteer = af.list('/volunteers', {
      query: {
        limitToLast: 50
      }
    });
    // this.afAuth.auth.signInAnonymously();
    this.submitSuccess=false;
    this.afAuth.authState.subscribe(auth => {
      if (auth) {
        this.createForm();
      }
    });
  }

  ngOnInit() {
  }

  ngOnDestroy(){
    // this.afAuth.auth.signOut();
  }
  createForm() {
    this.volunteerForm = this.fb.group({
      first_name: ['' + this.afAuth.auth.currentUser.displayName.split(' ').slice(0, -1).join(' '), Validators.required],
      last_name: '' + this.afAuth.auth.currentUser.displayName.split(' ').slice(-1).join(' '),
      email: '' + this.afAuth.auth.currentUser.email,
      contact: ['', Validators.required],
      branch: ['', Validators.required],
      year: ['', Validators.required],
      roles: this.fb.array([]),
      gender: ['', Validators.required],
      student_type: ['', Validators.required],
      purpose: ['', Validators.required],
      ecell_for_them: ['', Validators.required]
    })
  }

  onChange(role: string, isChecked: boolean) {
    const rolesFormArray = <FormArray>this.volunteerForm.controls.roles;

    if (isChecked) {
      rolesFormArray.push(new FormControl(role));
    } else {
      const index = rolesFormArray.controls.findIndex(x => x.value === role)
      rolesFormArray.removeAt(index);
    }
  }

  save(): void {
    if (!this.volunteerForm.valid) {
      return;
    } else {
      const vol = [this.volunteerForm.getRawValue().first_name,
        this.volunteerForm.getRawValue().last_name,
        this.volunteerForm.getRawValue().email,
        this.volunteerForm.getRawValue().contact,
        this.volunteerForm.getRawValue().gender,
        this.volunteerForm.getRawValue().branch,
        this.volunteerForm.getRawValue().year,
        JSON.stringify(this.volunteerForm.getRawValue().roles),
        this.volunteerForm.getRawValue().purpose,
        this.volunteerForm.getRawValue().student_type,
        this.volunteerForm.getRawValue().ecell_for_them
        ];
       this.volunteer.push({data : vol});
      this.volunteerForm.reset();
       this.submitSuccess=true;
  }
  }

}



// WEBPACK FOOTER //
// D:/Projects/angular/ecell-hcst/src/app/basic-info/basic-info.component.ts